import type { SessionUser } from './session-types'

const permissionImplications: Readonly<Record<string, readonly string[]>> = {
  FINANCIAL_CACHE_MANAGE: ['FINANCIAL_CACHE_READ'],
  SALE_REFUND: ['SALE_READ'],
  SUBSCRIPTION_MANAGE: ['SALE_READ'],
  EVENT_RETRY: ['EVENT_READ'],
  RECONCILE_RUN: ['RECONCILE_READ'],
  PRODUCT_WRITE: ['PRODUCT_READ'],
  OPS_ALERT_MANAGE: ['OPS_ALERT_READ'],
  USER_MANAGE: ['USER_READ'],
  USER_PLAN_MANAGE: ['USER_READ'],
  ACQUIRER_MANAGE: ['ACQUIRER_READ'],
  CHECKOUT_EXPERIENCE_MANAGE: ['CHECKOUT_EXPERIENCE_READ'],
}

export function hasAdminPermission(user: SessionUser | null, required: string): boolean {
  if (user?.isSuper === true) return true
  const pending = [...(user?.permissions ?? [])]
  const visited = new Set<string>()
  while (pending.length > 0) {
    const permission = pending.pop()!
    if (permission === required) return true
    if (visited.has(permission)) continue
    visited.add(permission)
    pending.push(...(permissionImplications[permission] ?? []))
  }
  return false
}
